import React from "react"
import { Stack, Text } from "../../../vanilla"

  export const FieldWithSubtext = ({
    children,
    subtext,
    hasError
  }: {
    children: React.ReactNode
    subtext?: string
    hasError: boolean
  }) => (
    <Stack spacing="4px">
      {children}
      {subtext && !hasError && (
        <Text variant="text1" color="textMuted">
          {subtext}
        </Text>
      )}
    </Stack>
  )